const FooterSection = () => (
  <footer className="border-t border-border bg-background px-4 py-10">
    <div className="container mx-auto text-center">
      <div className="mb-4 text-2xl font-extrabold text-primary" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
        E-forma
      </div>
      <p className="mb-2 text-xs text-muted-foreground">
        Certifié Qualiopi — Bilan de compétences
      </p>
      <div className="mb-4 flex flex-wrap items-center justify-center gap-3 text-xs text-muted-foreground">
        <span>Mentions légales</span>
        <span>•</span>
        <span>Politique de confidentialité</span>
        <span>•</span>
        <span>CGV</span>
      </div>
      <p className="mt-2 text-xs text-muted-foreground">
        © {new Date().getFullYear()} E-forma — Tous droits réservés
      </p>
    </div>
  </footer>
);

export default FooterSection;
